<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_trae_un_amigo.jpg" style="width: 100%" />
    <p class="tituloTarjeta">CONSIGUE DESCUENTOS PARA TI Y PARA TUS AMIGOS </p>
    <p>
        Comparte estos códigos con tus familiares o amigos y les daremos la bienvenida con 
        descuentos de hasta el 20% por nuevo cliente y a ti te aplicaremos 
        el mismo descuento en la renovación de tu póliza
    </p>

    <CuponAmigo v-for="item in portfolio.lstCodigosAmigo" :key="item.cupon" :cupon="item" />

    <ul>
        <li>
          <p class="condiciones"> Consulta condiciones <a href="https://www.mmtseguros.com/condiciones-bases" target="_blank" class="link">aquí</a> </p>
        </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },

  computed: {
    portfolio() {
      return this.$store.state.portfolio;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

.divHorizontal {
  display: inline-block;
  text-align: center;
}

.divCuponAmigo {
  align-items: center;
  justify-content: center;
}

.condiciones {
  font-size: calc(1em - 1pt);
}
</style>
